var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Clinic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18.667,
    viewBox: "0 0 21 18.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_store_mall_directory_24px",
    d: "M22.833,4H4.167V6.333H22.833ZM24,15.667V13.333L22.833,7.5H4.167L3,13.333v2.333H4.167v7H15.833v-7H20.5v7h2.333v-7ZM13.5,20.333h-7V15.667h7Z",
    transform: "translate(-3 -4)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/clinic.8b55c0a6d8e382cf29b8a35314d27532.svg";
export { ForwardRef as ReactComponent };